export default {
    registerTitle: 'Register here',
    register: 'Register',
    registerWithGoogle: 'Register with Google',
    registerWithOutlook: 'Register with Outlook',
    registerWithApple: 'Register with Apple',
    registerError: 'An error occurred while register',
    userRegistered: 'This user is already registered.',
    completeRegistration: 'Complete your registration',
    send: 'Send',
    registerSuccess: 'Successful registration',


};
